import { QueryExpression } from "./QueryExpression.js";
/**
 * Type for query builder callbacks
 */
/**
 * Represents an instance of a Query expression.
 * Usage example:
 * ```ts
 * const query = new Query(q => q.TypeIs('Task').And.Equals('DisplayName', 'Test'))
 * console.log(query.toString());   // the content query expression
 * ```
 */
export class Query {
  /**
   * Appends a new QuerySegment to the existing Query
   * @param {QuerySegment<T>} newSegment The Segment to be added
   */
  addSegment(newSegment) {
    this.segments.push(newSegment);
  }

  /**
   * Creates a stringified Content Query from the Query object
   * @returns {String} The Query expression as a sensenet Content Query
   */
  toString() {
    return this.segments.map(s => s.toString()).join('');
  }

  /**
   * Constructs a Query instance
   * @param build the Query Builder expression
   */
  constructor(build) {
    this.segments = [];
    const firstExpression = new QueryExpression(this);
    build(firstExpression);
  }
}
//# sourceMappingURL=Query.js.map